<ul v-if="token_exists" class="navbar-nav d-flex flex-row text-xs fw-500">
  <!-- Notification Trigger -->
  <li class="nav-item position-relative">
    <a
      class="nav-link text-dark text-sm d-none d-xl-flex"
      :href="`#${offcanvas_id}`"
      :id="dropdown_id"
      role="button"
      data-bs-toggle="offcanvas"
      :aria-controls="offcanvas_id"
    >
      <i class="bx bxs-bell fs-2 text-dark"></i>

      <span
        v-if="unreadCount > 0"
        class="count-badge badge rounded-pill bg-danger"
      >
        {{ unreadCount }}
      </span>
    </a>

    <!-- Dropdown Menu -->
    <ul
      class="notifications-dropdown dropdown-menu justify-content-end p-2 shadow border-0 d-none"
      :aria-labelledby="dropdown_id"
    >
      <li class="dropdown-item-text border-bottom pb-2 mb-2">
        <div class="d-flex align-items-center justify-content-between gap-2">
          <span class="fw-bold">Notifications</span>
          <div class="d-flex align-items-center gap-2">
            <button
              v-if="unreadCount > 0"
              type="button"
              class="btn btn-link btn-sm p-0 text-decoration-none text-xxs"
              :disabled="isMarkingAllRead"
              @click.stop="mark_all_notifications_as_read"
            >
              Mark all read
            </button>
            <button
              v-if="notifications.length > 0"
              type="button"
              class="btn btn-link btn-sm p-0 text-danger text-decoration-none text-xxs"
              :disabled="isClearingNotifications"
              @click.stop="clear_all_notifications"
            >
              Clear all
            </button>
          </div>
        </div>
      </li>

      <li
        v-for="notification in notifications"
        :key="notification.id"
        class="notification-item"
        :class="{ unread: !notification.is_read }"
      >
        <div class="noti-card d-flex justify-content-between gap-2">
          <!-- LEFT SIDE -->
          <div
            class="noti-body pointer min-w-0"
            @click="handle_notification_click(notification)"
          >
            <div class="noti-message">{{ notification.message }}</div>

            <div
              v-if="!notification.is_read"
              class="mark-read text-xxs"
              @click.stop="notification_read(notification)"
            >
              ✓ Mark as read
            </div>
          </div>

          <!-- RIGHT SIDE -->
          <div class="noti-actions d-flex flex-column align-items-end">
            <button
              class="noti-close pointer"
              @click.stop="delete_notification(notification)"
            >
              <i class="bx bx-x fs-5 fw-bold"></i>
            </button>

            <span class="noti-time text-muted text-xxs">
              {{ format_date(notification.date) }}
            </span>
          </div>
        </div>
      </li>

      <li v-if="notifications.length === 0" class="dropdown-item text-center">
        No notifications
      </li>
    </ul>
  </li>

  <!-- Mobile bell -->
  <li v-if="token_exists">
    <a
      class="text-dark text-sm d-xl-none"
      :href="`#${offcanvas_id}`"
      role="button"
      data-bs-toggle="offcanvas"
      :aria-controls="offcanvas_id"
    >
      <i class="bx bxs-bell fs-1 text-dark"></i>

      <span
        v-if="unreadCount > 0"
        class="position-absolute start-40 translate-middle badge rounded-pill bg-danger"
      >
        {{ unreadCount }}
      </span>
    </a>
  </li>
</ul>

<!-- Offcanvas -->
<div
  class="offcanvas offcanvas-end notification-offcanvas"
  tabindex="-1"
  :id="offcanvas_id"
  :aria-labelledby="offcanvas_id"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="offcanvasExampleLabel">Notifications</h5>
    <div class="d-flex align-items-center gap-3">
      <button
        v-if="unreadCount > 0"
        type="button"
        class="btn btn-link btn-sm p-0 text-decoration-none"
        :disabled="isMarkingAllRead"
        @click="mark_all_notifications_as_read"
      >
        Mark all read
      </button>
      <button
        v-if="notifications.length > 0"
        type="button"
        class="btn btn-link btn-sm p-0 text-danger text-decoration-none"
        :disabled="isClearingNotifications"
        @click="clear_all_notifications"
      >
        Clear all
      </button>
      <button
        type="button"
        class="btn-close notification-offcanvas-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
  </div>

  <div class="offcanvas-body p-2">
    <div
      v-for="notification in notifications"
      :key="notification.id"
      class="notification-item"
      :class="{ unread: !notification.is_read }"
    >
      <div class="noti-card d-flex justify-content-between gap-2">
        <!-- LEFT SIDE -->
        <div
          class="noti-body pointer min-w-0"
          @click="handle_notification_click(notification)"
        >
          <div class="noti-message">{{ notification.message }}</div>

          <div
            v-if="!notification.is_read"
            class="mark-read text-xxs"
            @click.stop="notification_read(notification)"
          >
            ✓ Mark as read
          </div>
        </div>

        <!-- RIGHT SIDE -->
        <div class="noti-actions d-flex flex-column align-items-end">
          <button
            class="noti-close pointer"
            @click.stop="delete_notification(notification)"
          >
            <i class="bx bx-x fs-5 fw-bold"></i>
          </button>

          <span class="noti-time text-muted text-xxs">
            {{ format_date(notification.date) }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="notifications.length === 0" class="text-center py-3">
      No notifications
    </div>
  </div>
</div>
